import {
    ENQUEUE_SNACKBAR,
    CLOSE_SNACKBAR,
    REMOVE_SNACKBAR,
    INCREMENT_OUTSTANDING_REQUEST_COUNT,
    DECREMENT_OUTSTANDING_REQUEST_COUNT,
    Notification,
    NotificationOptions,
    DispatchNotificationAction,
    NotificationActionTypes
} from "./types";
import { Close as CloseIcon } from "@mui/icons-material";
import { IconButton, ErrorAlert, SuccessAlert, DetailedErrorAlert, WarningAlert, InfoAlert } from "../../shared/components";
import _ from "lodash";

export function enqueueSnackbar(notification: Notification) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                ...notification,
                key: _.uniqueId("notification-"),
                options: {
                    action: key => (
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => dispatch(closeSnackbar(key))}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    ),
                    ...notification.options
                }
            },
        });
    }
}

export function closeSnackbar(key?: string): NotificationActionTypes {
    return {
        type: CLOSE_SNACKBAR,
        dismissAll: !key, // dismiss all if no key has been defined
        key,
    }
}

export function removeSnackbar(key: string): NotificationActionTypes {
    return {
        type: REMOVE_SNACKBAR,
        key,
    }
}

export function showError(errorMessage: string, options: NotificationOptions = {}) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                message: errorMessage,
                key: _.uniqueId("notification-"),
                options: {
                    content: (key, message) => <ErrorAlert id={key} children={message} onClose={() => dispatch(closeSnackbar(key))} />,
                    variant: 'error',
                    persist: true,
                    ...options
                }
            },
        })
    }
}

export function showDetailedError(errorMessage: string, details = "", options: NotificationOptions = {}) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                message: errorMessage,
                details: details,
                key: _.uniqueId("notification-"),
                options: {
                    content: (key, message) => <DetailedErrorAlert id={key} message={message} details={details} />,
                    variant: 'error',
                    persist: true,
                    ...options
                }
            },
        })
    }
}

export function showSuccess(successMessage: string, options: NotificationOptions = {}) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                message: successMessage,
                key: _.uniqueId("notification-"),
                options: {
                    content: (key, message) => <SuccessAlert id={key} children={message} onClose={() => dispatch(closeSnackbar(key))} />,
                    variant: "success",
                    ...options
                }
            }
        });
    }
}

export function showWarning(message: string, options: NotificationOptions = {}) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                message: message,
                key: _.uniqueId("notification-"),
                options: {
                    content: (key, message) => <WarningAlert id={key} children={message} onClose={() => dispatch(closeSnackbar(key))} />,
                    variant: "warning",
                    ...options
                }
            }
        });
    }
}

export function showInfo(message: string, options: NotificationOptions = {}) {
    return (dispatch: DispatchNotificationAction) => {
        dispatch({
            type: ENQUEUE_SNACKBAR,
            notification: {
                message: message,
                key: _.uniqueId("notification-"),
                options: {
                    content: (key, message) => <InfoAlert id={key} children={message} onClose={() => dispatch(closeSnackbar(key))} />,
                    variant: "info",
                    ...options
                }
            }
        });
    }
}

export function incrementOutstandingRequestCount() {
    return {
        type: INCREMENT_OUTSTANDING_REQUEST_COUNT
    }
}

export function decrementOutstandingRequestCount() {
    return {
        type: DECREMENT_OUTSTANDING_REQUEST_COUNT
    }
}